<template>
	<!-- 巡视信息列表 -->
	<div class="mod-config">
		<div>
			<el-card style="margin-top: -5px;" body-style="height: 100%;">
				<div class="title"> 项目文件库 </div>
				<div class="line"></div>
				<el-row
					style="border-bottom: #dadada 1px solid;margin-left: -20px;margin-top: -10px;background-color: rgb(243, 247, 247);">
					<el-col :span="5" style="border-right: 1px solid #dadada;">
						<el-row class="sec-title">监理文件</el-row>
					</el-col>
					<el-col :span="19">
						<el-row style="padding-top: 6px;">
							<el-col :span="10" style="margin-left: 10px;">
								<span>文件名称</span>
								<span style="display: inline-block;margin-left: 8px;">
									<el-input class="selSearchInput" placeholder="文件名称" v-model="fileName"></el-input>
								</span>
							</el-col>
							<el-col :span="4">
								<el-button v-preventReClick class="btn" type="primary" size="small"
									@click="selGetDataList()">查询</el-button>
								<el-button v-preventReClick class="rebtn" size="small"
									@click="resetFormData()">重置</el-button>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row style="border-bottom: #dadada 1px solid;margin-left: -20px;"">
					<el-col :span="5" style="border-right: 1px solid #dadada;" :height="screenHeight - 2 + 'px'">
					<el-row class="sec-but">
						<el-button v-preventReClick class="btn" type="primary" size="small"
							@click="fileKindSettingHandle()">文件类型设置</el-button>
					</el-row>
					</el-col>
					<el-col :span="19">
						<el-row style="padding: 4px 0;">
							<el-col :span="9" style="margin-left:20px;">
								<el-button class="btn" type="primary" size="small"
									@click="addOrUpdateBatchHandle()">上传</el-button>
								<el-button v-preventReClick class="btn" type="primary" size="small"
									:disabled="disabledBatchDelete" @click="deleteBatchHandle()">删除</el-button>
								<el-button v-preventReClick class="btn" type="primary" size="small"
									@click="fileTemplateHandle()">程序文件模版下载</el-button>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row style="margin-left: -20px;"">
					<el-col :span="5" style="border-right: 1px solid #dadada;">
						<div class="file-tree-container">
							<div class="file-tree">
								<div v-for="step in projectFilekindList" :key="step.stepCode" class="step-item">
									<div class="step-header" :class="{ 'selected': isStepSelected(step.stepCode) }"
										@click="selectStep(step.stepCode)">
										<span class="expand-icon" @click.stop="toggleStep(step.stepCode)">{{ step.expanded ?
											'−' : '+' }}</span>
										{{ step.stepName }}
									</div>
									<div v-if="step.expanded" class="filekind-list">
										<div v-for="fileKind in step.records" :key="fileKind.filekindcode"
											class="filekind-item">
											<div class="filekind-header"
												:class="{ 'selected': isFileKindSelected(fileKind.filekindcode) }"
												@click="selectFileKindItem(step.stepCode, fileKind.filekindcode, fileKind.systemFlg)">
												<span class="expand-icon"
													v-if="fileKind.subList && fileKind.subList.length > 0"
													@click.stop="toggleFileKind(fileKind.filekindcode)">
													{{ fileKind.expanded ? '−' : '+' }}
												</span>
												{{ fileKind.filekindName }}
											</div>
											<div v-if="fileKind.expanded && fileKind.subList && fileKind.subList.length > 0"
												class="subclass-list" style="margin-top: 4px;">
												<div v-for="subItem in fileKind.subList" :key="subItem.subclasscode"
													class="subclass-item"
													:class="{ 'selected': isSubItemSelected(subItem.subclasscode) }"
													@click="selectSubItem(step.stepCode, fileKind.filekindcode, subItem.subclasscode, subItem.systemFlg)">
													{{ subItem.subclassname }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-col>
					<el-col :span="19">
						<div class="box" style="margin-top:-7px;margin-left: -1px;">
							<el-table :height="screenHeight - 255 + 'px'" :row-class-name="tableRowClassName" border
								:row-style="selectRowBackground" ref="dataListTable" class="dataListTable"
								:data="dataList" header-align="center" style="width: 100%; margin-bottom: 20px;"
								@selection-change="handleSelectionChange" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }" :row-key="getRowKeys" @select="handleSelect"
								@select-all="handleSelectAll">
								<el-table-column header-align="center" align="center" width="60" type="selection"
									label=" " :selectable="checkSelectable"></el-table-column>
								<el-table-column type="index" label="NO." width="60" align="center">
									<template slot-scope="scope">{{ (pageIndex2 - 1) * pageSize + scope.$index + 1
									}}</template>
								</el-table-column>
								<el-table-column prop="fileName" label="文件名称" header-align="center" align="left"
									show-overflow-tooltip>
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="small"
											@click="viewPdf(scope.row.filePath, scope.row.fileUri, scope.row.fileName)">{{
												scope.row.fileName }}</el-button>
									</template>
								</el-table-column>
								<el-table-column prop="uploadTime" label="上传时间" width="120" align="center">
								</el-table-column>
								<el-table-column prop="uploadMan" label="上传人" width="120" align="center">
								</el-table-column>
								<el-table-column prop="remark" label="备注" width="180" align="center">
								</el-table-column>
								<el-table-column label="操作" width="115px" align="left">
									<template slot-scope="scope">
										<el-button v-preventReClick type="text" size="mini"
											@click="updateDetailHandle(scope.row.fileRecno)"
											v-if="scope.row.fileSource == '2'">修改</el-button>
										<el-button v-preventReClick type="text" size="mini"
											@click="downLoadFile(scope.row.fileUri, scope.row.fileName)"
											v-if="scope.row.fileUri">下载</el-button>
										<!-- <el-button v-preventReClick type="text" size="mini"
											@click="addProjectHandOver(scope.row)"
											v-if="scope.row.fileUri">加入档案交接清单</el-button> -->
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
							@current-change="currentChangeHandle" :current-page="pageIndex"
							:page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
							layout="total, sizes, prev, pager, next, jumper">
						</el-pagination>
					</el-col>
				</el-row>
			</el-card>
		</div>
		<add-batch v-if="addBatchVisible" ref="addBatch" @refreshDataList="getDataList()"></add-batch>
		<add-single v-if="addSingleVisible" ref="addSingle" @refreshDataList="getDataList()"></add-single>
		<view-pdf v-if="viewPdfVisible" ref="viewPdf" @refreshDataList="dataList"></view-pdf>
		<update-detail v-if="updateDetailVisible" ref="updateDetail" @refreshDataList="getDataList()"></update-detail>
		<file-template v-if="fileTemplateVisible" ref="fileTemplate"></file-template>
		<fileKind-setting v-if="fileKindSettingVisible" ref="fileKindSetting"
			@refreshDataList="getProjectFileKindList()"></fileKind-setting>
	</div>
</template>
<script>
import $common from "@/utils/common.js"
import AddBatch from './filedetail-add-batch'
import AddSingle from './filedetail-add-single'
import UpdateDetail from './filedetail-update'
import FileTemplate from './file-template'
import FileKindSetting from './filekind-setting'
import ViewPdf from "../projectInfo/viewPdf.vue"
export default {
	data() {
		return {
			screenHeight: 0,
			form: '',
			projectFilekindList: [],
			selectFileKind: {
				stepCode: '',
				filekindcode: '',
				subclasscode: '',
				systemFlg: ''
			},
			fileName: '',
			dataList: [],
			disabledBatchDelete: true,
			addBatchVisible: false,
			addSingleVisible: false,
			updateDetailVisible: false,
			fileTemplateVisible: false,
			viewPdfVisible: false,
			fileKindSettingVisible: false,
			tableSelVal: [],
			//当前页码
			pageIndex: 1,
			// 显示序号
			pageIndex2: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,
			existHandoverFile: false
		};
	},
	components: {
		AddBatch,
		AddSingle,
		ViewPdf,
		UpdateDetail,
		FileTemplate,
		FileKindSetting
	},
	mounted() {
		this.existHandoverFile = false
		this.screenHeight = window.innerHeight
		this.workNo = $common.getItem("workNo")
		this.getProjectFileKindList();
		this.getDataList()
	},
	methods: {
		resetFormData() {
			this.fileName = "";
			this.pageIndex = 1
			this.getDataList();
		},
		getInfoName() {
			this.$http({
				url: this.$store.state.httpUrl + "/index/infoName/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.handoverFilePath = data.body.handoverFilePath;
					if (this.handoverFilePath != null && this.handoverFilePath != '') {
						this.existHandoverFile = true;
						console.log("existHandoverFile true")
					} else {
						this.existHandoverFile = false;
						console.log("existHandoverFile false")
					}
				}
			});
		},
		getProjectFileKindList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectfilekind/list/" + $common.getItem("workNo"),
				method: 'get',
				params: this.$http.adornParams({
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// 初始化 expanded 属性
					this.projectFilekindList = this.initExpandedState(data.body.records);
				}
			})
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		getDataList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectfiledetail/list",
				method: 'get',
				params: this.$http.adornParams({
					limit: this.pageSize,
					page: this.pageIndex,
					workNo: $common.getItem("workNo"),
					stepCode: this.selectFileKind.stepCode,
					filekindcode: this.selectFileKind.filekindcode,
					subclasscode: this.selectFileKind.subclasscode,
					fileName: this.fileName,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.recordList;
					this.totalPage = data.body.totalCount;
					this.pageIndex2 = this.pageIndex

					this.getInfoName()
				}
			})
		},
		// 初始化展开状态
		initExpandedState(data) {
			return data.map(step => {
				return {
					...step,
					expanded: false, // 默认展开步骤
					records: step.records ? step.records.map(fileKind => {
						return {
							...fileKind,
							expanded: false // 默认展开文件类型
						}
					}) : []
				}
			});
		},
		toggleStep(stepCode) {
			const step = this.projectFilekindList.find(s => s.stepCode === stepCode);
			if (step) {
				step.expanded = !step.expanded;
				// 强制更新视图
				this.$forceUpdate();
			}
		},
		toggleFileKind(fileKindCode) {
			for (const step of this.projectFilekindList) {
				const fileKind = step.records.find(f => f.filekindcode === fileKindCode);
				if (fileKind) {
					fileKind.expanded = !fileKind.expanded;
					// 强制更新视图
					this.$forceUpdate();
					break;
				}
			}
		},
		// 选中步骤
		selectStep(stepCode) {
			this.selectFileKind = {
				stepCode: stepCode,
				filekindcode: '',
				subclasscode: '',
				systemFlg: ''
			};
			this.pageIndex = 1
			this.getDataList();
		},
		// 选中文件类型
		selectFileKindItem(stepCode, filekindcode, systemFlg) {
			this.selectFileKind = {
				stepCode: stepCode,
				filekindcode: filekindcode,
				subclasscode: '',
				systemFlg: systemFlg
			};
			this.pageIndex = 1
			this.getDataList();
		},
		// 选中子项
		selectSubItem(stepCode, filekindcode, subclasscode, systemFlg) {
			this.selectFileKind = {
				stepCode: stepCode,
				filekindcode: filekindcode,
				subclasscode: subclasscode,
				systemFlg: systemFlg
			};
			this.pageIndex = 1
			this.getDataList();
		},
		// 判断步骤是否选中
		isStepSelected(stepCode) {
			return this.selectFileKind.stepCode === stepCode && this.selectFileKind.filekindcode === '' && this.selectFileKind.subclasscode === '';
		},
		// 判断文件类型是否选中
		isFileKindSelected(filekindcode) {
			return this.selectFileKind.filekindcode === filekindcode && this.selectFileKind.subclasscode === '';
		},
		// 判断子项是否选中
		isSubItemSelected(subclasscode) {
			return this.selectFileKind.subclasscode === subclasscode;
		},
		fileKindSettingHandle() {
			this.fileKindSettingVisible = true
			this.$nextTick(() => {
				this.$refs.fileKindSetting.init()
			})
		},
		addOrUpdateBatchHandle() {
			// 校验是否选中子类型
			if (this.selectFileKind == null || (this.selectFileKind.stepCode === '' || this.selectFileKind.filekindcode === '' || this.selectFileKind.subclasscode === '')) {
				this.$message.error("先从左侧选择要上传的文件类型！")
				return
			}

			// 定义系统保留的子类型编码列表
			let subclasscodeList = [
				'010101', // 监理/建造合同
				'010102', // 技术方案/标书
				'010103', // 合同评审意见书
				'010301', // 监理规划
				'010302', // 监理实施细则
			];

			// 校验是否是系统保留的子类型
			if (subclasscodeList.includes(this.selectFileKind.subclasscode)) {
				this.$message.error("此文件来自主系统，不能在此处上传，请在主系统进行上传！");
				return;
			}

			// 若是交接清单，则只能上传一个文件
			if (this.selectFileKind.subclasscode == '040105') {
				// 判断是否已经有交接清单文件
				if (this.existHandoverFile) {
					this.$message.error('"监理档案交接清单"只能上传一个文件，请先删除现有文件!');
					return;
				} else {
					this.addSingleVisible = true
					this.$nextTick(() => {
						this.$refs.addSingle.init(this.selectFileKind)
					})
				}
			} else {
				this.addBatchVisible = true
				this.$nextTick(() => {
					this.$refs.addBatch.init(this.selectFileKind)
				})
			}
		},
		updateDetailHandle(fileRecno) {
			this.updateDetailVisible = true
			this.$nextTick(() => {
				this.$refs.updateDetail.init(fileRecno)
			})
		},
		fileTemplateHandle() {
			this.fileTemplateVisible = true
			this.$nextTick(() => {
				this.$refs.fileTemplate.init()
			})
		},
		// 设置行的唯一key
		getRowKeys(row) {
			return row.fileRecno;
		},
		// 检查是否可选
		checkSelectable(row) {
			return row.fileSource === '2';
		},
		// 处理选择变化
		handleSelectionChange(val) {
			// 只保留 fileSource=2 的选中项
			const filteredVal = val.filter(item => item.fileSource === '2');
			this.tableSelVal = filteredVal;
			if (filteredVal.length > 0) {
				this.disabledBatchDelete = false;
			} else {
				this.disabledBatchDelete = true;
			}
		},
		// 处理单选
		handleSelect(selection, row) {
			if (row.fileSource !== '2') {
				// 如果不是 fileSource=2 的行，取消选中
				this.$refs.dataListTable.toggleRowSelection(row, false);
			}
		},
		// 处理全选
		handleSelectAll(selection) {
			// 取消所有 fileSource 不是 2 的行的选中状态
			if (selection.length > 0) {
				this.dataList.forEach(row => {
					if (row.fileSource !== '2') {
						this.$refs.dataListTable.toggleRowSelection(row, false);
					}
				});
			}
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableRowClassName({ row, rowIndex });
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVal.map((item) => item.fileRecno);
			if (checkIdList.includes(row.fileRecno)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
		addProjectHandOver(item) {
			const _url = "/business/projecthandoverlist/save";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					fileName: item.fileName,
					templatePath: item.filePath
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
				} else {
					this.$message.error(data.msg);
				}
			});
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val
			this.pageIndex = 1
			this.getDataList()
		},
		// 当前页
		currentChangeHandle(val) {
			if (val) {
				this.pageIndex = val
			} else {
				this.pageIndex = 1
			}
			this.getDataList()
		},
		downLoadFile(fileUri, filename) {
			filename = this.getSuffix(fileUri, filename)
			this.getBlob(fileUri, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		viewPdf(filePath, fileUri, filename) {
			// pdf和doc文件，需要pdf在线预览，其他类型文件直接下载
			let suffixType = fileUri.substr(fileUri.lastIndexOf(".") + 1)
			if (suffixType != '' && (suffixType === 'pdf' || suffixType === 'doc' || suffixType === 'docx')) {
				this.viewPdfVisible = true;
				this.$nextTick(() => {
					this.$refs.viewPdf.init(filename, filePath)
				})
			} else {
				filename = this.getSuffix(fileUri, filename)
				this.getBlob(fileUri, (blob) => {
					this.saveAs(blob, filename)
				})
			}
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		deleteBatchHandle() {
			this.$confirm(`确定对选中的数据进行删除操作？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let recIds = this.tableSelVal.map((item) => item.fileRecno);
				this.$http({
					url: this.$store.state.httpUrl + `/business/projectfiledetail/deleteBatch`,
					method: 'post',
					data: this.$http.adornData({
						records: recIds
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					}
				});
			})
				.catch(() => { })
		},
	}
};
</script>
<style lang="scss" scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

.tree-container {
	background-color: white;
}

.treeText {
	white-space: nowrap;
	/*设置不换行*/
	overflow: hidden;
	/*设置隐藏*/
	text-overflow: ellipsis;
	/*设置隐藏部分为省略号*/
}

.dataListTable {
	margin-top: 5px;
}

.my-pagination {
	margin-right: 20px !important;
}

// 设置表头样式
::v-deep(.el-table th.el-table__cell) {
	// background-color: #d3e2f4 !important;
	font-size: 15px;
	padding: 2px 0;
}

.line1 {
	margin-top: 8px;
	margin-left: -10px;
	margin-bottom: 10px;
	width: 100%;
	height: 2px;
	background: rgb(190, 187, 187);
}

::v-deep(.selSearchInput .el-input__inner) {
	width: 200px !important;
	height: 30px !important;
}

::v-deep(.selFormItem .el-form-item__label) {
	font-size: smaller;
}

.file-tree-container {
	height: calc(100vh - 255px);
	overflow-y: auto;
	border-right: 1px solid #dadada;
}

.file-tree {
	font-family: Arial, sans-serif;
	user-select: none;
}

.step-item {
	margin-bottom: 10px;
}

.step-header {
	font-weight: bold;
	font-size: 16px;
	padding: 5px 4px;
	cursor: pointer;
	display: flex;
	align-items: center;
	transition: background-color 0.2s;
}

.step-header:hover {
	background-color: #d0e8ff;
}

.step-header.selected {
	background-color: #9bc9f3 !important;
}

.filekind-list {
	margin-left: 20px;
}

.filekind-item {
	margin: 8px 0;
}

.filekind-header {
	font-weight: bold;
	padding: 5px 4px;
	cursor: pointer;
	display: flex;
	align-items: center;
	transition: background-color 0.2s;
}

.filekind-header:hover {
	background-color: #e8f5e8;
}

.filekind-header.selected {
	background-color: #9bc9f3 !important;
}

.subclass-list {
	margin-left: 20px;
}

.subclass-item {
	padding: 5px 4px;
	transition: background-color 0.2s;
	cursor: pointer;
}

.subclass-item:hover {
	background-color: #f9f9f9;
}

.subclass-item.selected {
	background-color: #9bc9f3 !important;
}

.expand-icon {
	display: inline-block;
	width: 16px;
	height: 16px;
	text-align: center;
	line-height: 14px;
	margin-right: 8px;
	background-color: #fff;
	border: 1px solid #ddd;
	border-radius: 2px;
	font-size: 12px;
	font-weight: bold;
	cursor: pointer;
}

.sec-title {
	text-align: center;
	font-weight: bolder;
	font-size: large;
	padding: 10px 0;
}

.sec-but {
	text-align: right;
	font-weight: bolder;
	font-size: large;
	padding: 3px 2px 3px 0;
}
</style>